import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { DeviceType } from 'src/common/enumerations/device-type';
import { useStyles } from './device-button-styles';
import DeviceIcon from '../device-icon';
import DeviceStatusIcon from '../device-status-icon';

interface Props {
  text: string;
  selected?: boolean;
  operational?: boolean;
  type?: DeviceType;
  onClick: () => void;
}

const DeviceButton: React.FC<Props> = (props: Props): JSX.Element => {
  const { text, selected, operational, type, onClick } = props;
  const classes = useStyles({ selected, operational });

  return (
    <BaseButton
      data-testid={`device-button${selected ? '-selected' : ''}`}
      fullWidth
      buttonType='white'
      onClick={onClick}
      className={classes.root}
    >
      <Grid container alignItems='center' wrap='nowrap'>
        <DeviceIcon type={type} operational={operational} className={classes.icon} />
        <Grid container item zeroMinWidth>
          <Typography
            data-testid={`${selected ? 'selected' : 'unselected'}-device-name`}
            noWrap
            variant='subtitle1'
            className={classes.label}
          >
            {text}
          </Typography>
        </Grid>
        <DeviceStatusIcon operational={operational} className={classes.icon} />
      </Grid>
    </BaseButton>
  );
};

export default DeviceButton;
